"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _FormModal = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/FormModal"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Fields = _interopRequireDefault(require("./components/Fields/Fields"));
var _utils = require("./components/GrantTypes/utils");
var _validations = require("./components/GrantTypes/validations");
var _hooks = require("./hooks");
var _applications = require("./utils/applications");
var _state = require("./utils/state");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  "modal": "ClientApplicationModal__modal__JKF2i",
  "header": "ClientApplicationModal__header__WUx3U",
  "body": "ClientApplicationModal__body__lDg1j",
  "footer": "ClientApplicationModal__footer__SweHu",
  "title": "ClientApplicationModal__title__1hxa-",
  "spinner": "ClientApplicationModal__spinner__2eXEW",
  "try-again-button": "ClientApplicationModal__try-again-button__2UIHO",
  "tryAgainButton": "ClientApplicationModal__try-again-button__2UIHO",
  "modal-body": "ClientApplicationModal__modal-body__2QzpV",
  "modalBody": "ClientApplicationModal__modal-body__2QzpV"
}; 
require('./ClientApplicationModal.css');
var ClientApplicationModal = function ClientApplicationModal(props) {
  var application = props.application,
    className = props.className,
    assetType = props.assetType,
    instanceId = props.instanceId,
    providerId = props.providerId,
    onGetGrantTypes = props.onGetGrantTypes,
    onCreateApplication = props.onCreateApplication,
    onEditApplication = props.onEditApplication;
  var anypointRedirectURIs = (0, _hooks.useAnypointRedirectURIs)();
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var _React$useState = _react.default.useState((0, _state.initializeForm)(anypointRedirectURIs, application)),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    formState = _React$useState2[0],
    setForm = _React$useState2[1];
  var _React$useState3 = _react.default.useState({
      errors: [],
      isConfigurable: true,
      errorFetchingGrantTypes: null,
      isGrantTypesDirty: false,
      areGrantTypesLoading: false,
      grantTypes: []
    }),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    grantTypesState = _React$useState4[0],
    setGrantTypes = _React$useState4[1];
  var _React$useState5 = _react.default.useState(false),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isSubmitting = _React$useState6[0],
    setIsSubmitting = _React$useState6[1];
  var getIdentityProvider = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(targetProviderId) {
      var _yield$onGetGrantType, grantTypes, isConfigurable, identityManagementType, grantTypesFields;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                areGrantTypesLoading: true
              });
            });
            _context.next = 4;
            return onGetGrantTypes({
              providerId: targetProviderId
            });
          case 4:
            _yield$onGetGrantType = _context.sent;
            grantTypes = _yield$onGetGrantType.grantTypes;
            isConfigurable = _yield$onGetGrantType.isConfigurable;
            identityManagementType = _yield$onGetGrantType.identityManagementType;
            grantTypesFields = (0, _state.buildGrantTypesFields)(grantTypes);
            setForm(function ($formState) {
              return _objectSpread(_objectSpread({}, grantTypesFields), $formState);
            });
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                grantTypes: grantTypes,
                isConfigurable: isConfigurable,
                identityManagementType: identityManagementType,
                areGrantTypesLoading: false
              });
            });
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.error(_context.t0);
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                errorFetchingGrantTypes: _context.t0,
                areGrantTypesLoading: false
              });
            });
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 13]]);
    }));
    return function getIdentityProvider(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  _react.default.useEffect(function () {
    var _application$clientPr;
    if (!application || (_application$clientPr = application.clientProvider) !== null && _application$clientPr !== void 0 && _application$clientPr.providerId) {
      var _application$clientPr2;
      getIdentityProvider(application ? application === null || application === void 0 || (_application$clientPr2 = application.clientProvider) === null || _application$clientPr2 === void 0 ? void 0 : _application$clientPr2.providerId : providerId);
    }
  }, []);
  var handleClose = function handleClose() {
    var options = {};
    if (application) {
      options.trackPayloadProps = {
        closeReason: 'cancel',
        isEditingApplication: true,
        applicationId: application.id
      };
    }
    closeModal(options);
    setForm({});
  };
  var handleChange = function handleChange(_ref2) {
    var value = _ref2.value,
      target = _ref2.target;
    var newState = (0, _state.buildStateFromFormChange)({
      value: value,
      target: target,
      grantTypes: grantTypesState.grantTypes,
      initialForm: formState
    });
    setForm(newState.form);
    setGrantTypes(function ($grantTypesState) {
      return _objectSpread(_objectSpread({}, $grantTypesState), newState.grantTypes);
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var formWithSelectedGrantTypes, grantTypeValidator, isValid, selectedGrantTypes, applicationParams;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            formWithSelectedGrantTypes = (0, _utils.mergeGrantTypes)(formState, grantTypesState.grantTypes);
            grantTypeValidator = (0, _validations.getGrantTypeValidator)({
              identityManagementType: grantTypesState.identityManagementType
            })({
              grantTypes: grantTypesState.grantTypes,
              form: formWithSelectedGrantTypes,
              isGrantTypesRequired: grantTypesState.isConfigurable
            });
            isValid = grantTypeValidator.validate();
            if (!(grantTypesState.grantTypes.length && !isValid)) {
              _context2.next = 6;
              break;
            }
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                errors: [new Error(grantTypeValidator.message)]
              });
            });
            return _context2.abrupt("return");
          case 6:
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                errors: []
              });
            });
            selectedGrantTypes = grantTypesState.grantTypes.map(function (grantType) {
              return grantType.name;
            }).filter(function (grantTypeName) {
              return formState[(0, _utils.getGrantTypeValueKey)(grantTypeName)];
            });
            applicationParams = {
              identityManagementType: grantTypesState.identityManagementType,
              name: formState.name,
              description: formState.description,
              url: formState.applicationURL,
              redirectURI: (0, _applications.getRedirectURIs)(anypointRedirectURIs, formState.redirectURI, formState.apiEndpoints),
              grantTypes: selectedGrantTypes,
              apiEndpoints: formState.apiEndpoints || false
            };
            setIsSubmitting(true);
            _context2.prev = 10;
            if (!application) {
              _context2.next = 17;
              break;
            }
            _context2.next = 14;
            return onEditApplication(_objectSpread(_objectSpread({}, applicationParams), {}, {
              applicationId: application.id
            }));
          case 14:
            trackEvent('Application updated', {
              identityManagementType: grantTypesState.identityManagementType,
              grantTypes: grantTypesState.grantTypes
            });
            _context2.next = 20;
            break;
          case 17:
            _context2.next = 19;
            return onCreateApplication(_objectSpread(_objectSpread({}, applicationParams), assetType === 'api-group' ? {
              apiGroupInstanceId: instanceId
            } : {
              apiInstanceId: instanceId
            }));
          case 19:
            trackEvent('Application created', {
              identityManagementType: grantTypesState.identityManagementType,
              grantTypes: grantTypesState.grantTypes
            });
          case 20:
            closeModal({
              trackPayloadProps: {
                closeReason: 'submit',
                isEditingApplication: !!application,
                applicationId: application === null || application === void 0 ? void 0 : application.id
              }
            });
            _context2.next = 26;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](10);
            setGrantTypes(function ($grantTypesState) {
              return _objectSpread(_objectSpread({}, $grantTypesState), {}, {
                errors: [_context2.t0]
              });
            });
          case 26:
            setIsSubmitting(false);
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[10, 23]]);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var renderBody = function renderBody() {
    if (grantTypesState.areGrantTypesLoading) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.spinner
      }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        center: true,
        size: "l"
      }));
    }
    if (grantTypesState.errorFetchingGrantTypes) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Something went wrong! Please", ' ', /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        "data-test-id": "retry-get-provider-button",
        className: styles.tryAgainButton,
        onClick: function onClick() {
          var _application$clientPr3;
          return getIdentityProvider(application === null || application === void 0 || (_application$clientPr3 = application.clientProvider) === null || _application$clientPr3 === void 0 ? void 0 : _application$clientPr3.providerId);
        }
      }, "try again"), ' ', "later");
    }

    // this should be called like this (and not as a React component), otherwise anypoint-components Form will not work
    return (0, _Fields.default)({
      errors: grantTypesState.errors,
      form: formState,
      isConfigurable: grantTypesState.isConfigurable,
      isGrantTypesDirty: grantTypesState.isGrantTypesDirty,
      identityManagementType: grantTypesState.identityManagementType,
      grantTypes: grantTypesState.grantTypes
    });
  };
  return /*#__PURE__*/_react.default.createElement(_FormModal.default, {
    title: application ? 'Edit application' : 'Create new application',
    className: (0, _classnames.default)(className, styles.modal),
    testId: "client-application",
    submitButtonText: application ? 'Update' : 'Create',
    body: renderBody(),
    onSubmit: handleSubmit,
    onChange: handleChange,
    onCancel: handleClose,
    form: formState,
    isLoading: isSubmitting
  });
};
ClientApplicationModal.defaultProps = {
  application: null,
  className: null,
  providerId: null,
  onCreateApplication: function onCreateApplication() {},
  onEditApplication: function onEditApplication() {}
};
var _default = exports.default = ClientApplicationModal;
//# sourceMappingURL=ClientApplicationModal.js.map